import { omit, union, merge } from 'ramda'
import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.H24_CATEGORIES_FETCH_SUCCESS:
        case ActionTypes.H24_CATEGORIES_IMPORT_SUCCESS:
            const { categories } = action.entities
            return {categories: merge(state.categories, categories)}
        case ActionTypes.H24_CATEGORIES_SAVE_SUCCESS:
            return { ...state, categories: { ...state.categories, ...action.data.entities.categories } }
        case ActionTypes.H24_CATEGORIES_DELETE_SUCCESS:
            return { categories: omit([action.data], state.categories) }
        case ActionTypes.H24_CURRENT_ORGANIZATION_CHANGE:
            return {}
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.H24_CATEGORIES_FETCH_SUCCESS:
        case ActionTypes.H24_CATEGORIES_IMPORT_SUCCESS:
            return union(state, action.result)
        case ActionTypes.H24_CATEGORIES_SAVE_SUCCESS:
            return union(state, [action.data.result])
        case ActionTypes.H24_CATEGORIES_DELETE_SUCCESS:
            return state.filter(item => item !== action.data)
        case ActionTypes.H24_CURRENT_ORGANIZATION_CHANGE:
            return []
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.H24_CATEGORIES_FETCH_REQUEST:
            return true
        case ActionTypes.H24_CATEGORIES_FETCH_SUCCESS:
        case ActionTypes.H24_CATEGORIES_FETCH_FAILURE:
        case ActionTypes.H24_CATEGORIES_SAVE_SUCCESS:
        case ActionTypes.H24_CATEGORIES_IMPORT_SUCCESS:
        case ActionTypes.H24_CATEGORIES_SAVE_FAILURE:
        case ActionTypes.H24_CATEGORIES_DELETE_SUCCESS:
        case ActionTypes.H24_CATEGORIES_DELETE_FAILURE:
        case ActionTypes.H24_CATEGORIES_IMPORT_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.H24_CATEGORIES_FETCH_FAILURE:
        case ActionTypes.H24_CATEGORIES_SAVE_FAILURE:
        case ActionTypes.H24_CATEGORIES_DELETE_FAILURE:
        case ActionTypes.H24_CATEGORIES_IMPORT_FAILURE:
            return action.error
        case ActionTypes.H24_CATEGORIES_FETCH_SUCCESS:
        case ActionTypes.H24_CATEGORIES_SAVE_SUCCESS:
        case ActionTypes.H24_CATEGORIES_DELETE_SUCCESS:
        case ActionTypes.H24_CATEGORIES_IMPORT_SUCCESS:
            return null
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/h24Reducers/h24Categories.js